import React, { useContext } from "react";

import styles from "./SubmitButton.module.scss";
import block from 'bem-css-modules';
import { AppContext } from "../../../../util/context";

import { sanitizeContent as s } from "../../../../util/functions";

const SubmitButton = (props: { submitBtnText: string, submitStarted: boolean, stepLabel: string }) => {
  const { disableButton } = useContext(AppContext);
  const {
    submitBtnText,
    submitStarted,
    stepLabel
  } = props;

  const b = block(styles);

  return (
    <div className={`fc-submit-button ${b()}`}>
      <button type="submit" disabled={submitStarted || disableButton} className={`event-tracking-step--${stepLabel}`} >
        <span dangerouslySetInnerHTML={{ __html: s(submitBtnText) }} />
      </button>
    </div>
  )
}

export default SubmitButton;